// extracted by mini-css-extract-plugin
export default {"Grid":"createDynamicBanner_Grid__+ssjX","Span":"createDynamicBanner_Span__uQynr"};